import { CanvasEdge, CanvasNode } from '../../../tabs/CampaignWorkflowTab/components/Canvas/Canvas';
import { CanvasState } from '../../../tabs/CampaignWorkflowTab/components/Canvas/state/CanvasState';
import { OnsiteCampaignResponse, OnsiteMessageSegment } from 'sections/onsite-campaigns/types';
import { State } from './states/State';
import { DefaultFlowState, DefaultFlowStateValidator } from './states/DefaultFlowState';
import { SingleFlowState, SingleFlowStateValidator } from './states/SingleFlowState';
import { BranchedState, BranchedStateValidator } from './states/BranchedState';

export type CampaignResponseModel = Omit<OnsiteCampaignResponse, 'onsiteMessageSegments'> & {
  onsiteMessageSegments: (OnsiteMessageSegment & { branchId: string })[];
};

export class CampaignResponseToCanvasStateAdapter implements CanvasState {
  public constructor(campaignResponse: CampaignResponseModel) {
    const canvas = CampaignResponseToCanvasStateAdapter.createFromResponse(campaignResponse);
    const { nodes, edges, showIntroVariant } = canvas.convertToState();

    this.nodes = nodes;
    this.edges = edges;
    this.showIntroVariant = showIntroVariant;
  }

  public showIntroVariant: boolean;
  public nodes: CanvasNode[];
  public edges: CanvasEdge[];

  public static createFromResponse(response: CampaignResponseModel) {
    const states: State[] = [
      new DefaultFlowState(new DefaultFlowStateValidator(response)),
      new SingleFlowState(new SingleFlowStateValidator(response), response),
      new BranchedState(new BranchedStateValidator(response), response),
    ];

    const state = states.map(s => s.createCanvas()).find(s => s !== undefined);
    if (!state) {
      throw Error('Unable to find the correct strategy to start your campaign');
    }

    return state;
  }
}
